module.exports = __webpack_public_path__ + "static/media/143.4f127fbf.png";